<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700">
      <v-card>
        <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
          <span class="headline">
            Edit Document Type
          </span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="toggleDialog"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Name"
                              :rules="[rules.exists]"
                              v-model="documentType.name">
                </v-text-field>

                <v-text-field label="Description"
                              v-model="documentType.description">
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <div v-if="disabled" class="text-center">
          Saving<br />
          <v-progress-circular indeterminate
                               color="success"
                               v-if="disabled"></v-progress-circular>
        </div>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="accent" dark depressed block @click="updateDocumentType" :disabled="disabled">Save</v-btn>
        </v-card-actions>
        <v-alert v-if="this.error != null || this.ruleError != null" dismissible color="error" dark>
          <v-icon size="20" dark>warning</v-icon>{{this.error}} {{this.ruleError}}
        </v-alert>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    documentTypeDetails: {
      type: Object
    }
  },
  data () {
    return {
      documentType: {
        name: null,
        description: null,
        slug: null
      },
      rules: {
        exists: value => !this.exists(this.slugify(value)) || 'This Document Type Name already exists.'
      },
      ruleError: null,
      disabled: false
    }
  },
  methods: {
    ...mapActions({
      update: 'documentType/updateDocumentType',
      clearErrors: 'documentType/clearErrors'
    }),
    toggleDialog () {
      this.ruleError = null
      this.clearErrors()
      this.toggle()
    },
    async updateDocumentType () {
      this.clearErrors()
      this.disabled = true

      if (this.documentType.name) {
        this.documentType.slug = this.slugify(this.documentType.name)
      }

      if (this.exists(this.documentType.slug)) {
        this.ruleError = 'Duplicates cannot be added, this document type may be archived'
      } else {
        await this.update(this.documentType)
        if (!this.error) {
          this.toggle()
        }
      }
      this.disabled = false
    },
    slugify (name) {
      if (name === undefined || name === null) {
        return name
      } else {
        return name.replace(/\s+/g, '-').toLowerCase()
      }
    },
    exists (value) {
      var exist = false

      if (this.documentTypeDetails.slug !== value) { //  in case they back space, and retype...name would already be in the list
        this.slugs.forEach((slug) => {
          if (slug.text === value) {
            exist = true
          }
        })
      }

      return exist
    }

  },
  computed: {
    ...mapGetters({
      documentTypes: 'documentType/types',
      slugs: 'documentType/slugs',
      error: 'documentType/error'
    })

  },
  watch: {
    documentTypeDetails (details) {
      this.documentType = details
    }
  }
}
</script>
